module.exports = __webpack_public_path__ + "static/media/cs_Corporate_Actions.40c4e0ec.png";